import BarChart from './BarChart.jsx';

function PopulationAgeChart({ data }) {
  const options = {
    xaxis: {
      categories: [
        '0-4',
        '5-9',
        '10-14',
        '15-19',
        '20-24',
        '25-29',
        '30-34',
        '35-39',
        '40-44',
        '45-49',
        '50-54',
        '55-59',
        '60-64',
        '65-69',
        '70-74',
        '75-79',
        '80-84',
        '85+',
      ],
    },
  };

  return (
    <BarChart
      series={data}
      options={options}
      title="Население по возрасту, человек"
    />
  );
}

export default PopulationAgeChart;
